function canvasToBlob(canvas: HTMLCanvasElement, type: string = 'image/png'): Promise<Blob> {
  return new Promise((resolve) => {
    canvas.toBlob(resolve, type)
  })
}

export default canvasToBlob